import { render, staticRenderFns } from "./KegiatanEdit.vue?vue&type=template&id=31c6e004&scoped=true"
import script from "./KegiatanEdit.vue?vue&type=script&lang=js"
export * from "./KegiatanEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c6e004",
  null
  
)

export default component.exports